import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
  useTheme,
} from "@mui/material";
import { WarningAmberOutlined } from "@mui/icons-material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { DIALOG_PROMPT_NS } from "./i18n";

export enum DialogPromptModalType {
  None = "None",
  Restart = "Restart",
  Reset = "Reset",
}

export interface IDialogPromptProps {
  isOpenModal: boolean;
  handleCloseModal: () => void;
  modalType: DialogPromptModalType;
  handleActionModal: () => void;
}

export const DialogPrompt = (props: IDialogPromptProps) => {
  const { isOpenModal, handleCloseModal, modalType, handleActionModal } = props;

  const { palette } = useTheme();
  const { t } = useTranslation(DIALOG_PROMPT_NS);

  const modalData = {
    [DialogPromptModalType.Restart]: {
      heading: t("restart.heading"),
      text: t("restart.text"),
      buttonText: t("restart.button"),
    },
    [DialogPromptModalType.Reset]: {
      heading: t("reset.heading"),
      text: t("reset.text"),
      buttonText: t("reset.button"),
    },
    [DialogPromptModalType.None]: null,
  };

  const activeModalData = modalData[modalType];

  const dialogPrompt = useMemo(() => {
    return (
      activeModalData && (
        <Dialog
          open={isOpenModal}
          onClose={handleCloseModal}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            <WarningAmberOutlined sx={{ color: palette.warning.main }} />
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Typography
                variant="h4"
                sx={{ textAlign: "left", color: "#fff", pb: "6px" }}
              >
                {activeModalData.heading}
              </Typography>
              <Typography variant="h5" sx={{ textAlign: "left" }}>
                {activeModalData.text}
              </Typography>
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ p: 2 }}>
            <Button
              sx={{
                color: "#fff",
                backgroundColor: "#2F3336",
                padding: "8px 32px",
                mr: 2,
                "&:hover": {
                  backgroundColor: "#414141",
                },
              }}
              onClick={handleCloseModal}
            >
              Cancel
            </Button>
            <Button
              sx={{
                color: "#000",
                backgroundColor: "#EDAA24",
                padding: "8px 32px",
                "&:hover": {
                  backgroundColor: "#c98b10",
                },
              }}
              onClick={handleActionModal}
            >
              {activeModalData.buttonText}
            </Button>
          </DialogActions>
        </Dialog>
      )
    );
  }, [
    handleActionModal,
    handleCloseModal,
    isOpenModal,
    activeModalData,
    palette,
  ]);

  return dialogPrompt;
};
